import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonBehaviorChangeService {

  //#region Set behavior object

  // Set login detection behavior
  private detectAddCartItems = new BehaviorSubject(false);
  currentAddCart = this.detectAddCartItems.asObservable();

  private getCartItems = new BehaviorSubject(false);
  currentrCartList = this.getCartItems.asObservable();

  private detectAddWishlistItems = new BehaviorSubject(false);
  currentAddWishlist = this.detectAddWishlistItems.asObservable();

  private getWishlistItems = new BehaviorSubject(false);
  currentWishList = this.getWishlistItems.asObservable();

  private updateProfile = new BehaviorSubject(false);
  currentUpdateProfile = this.updateProfile.asObservable();

  private getProfileUpdated = new BehaviorSubject(false);
  currentProfile = this.getProfileUpdated.asObservable();

  private getToastMessage = new BehaviorSubject(false);
  toastMessage = this.getToastMessage.asObservable();
  //#endregion Set behavior object

  constructor() {
  }

  /**
   * Summary: This method is used to detect login.
   * @param input: This input is a boolean for user login or not
   */
  addCart(input: any) {
    this.detectAddCartItems.next(input);
  }

  getCartList(input: any) {
    this.getCartItems.next(input);
  }

  addWishlist(input: any) {
    this.detectAddWishlistItems.next(input);
  }

  getWishList(input: any) {
    this.getWishlistItems.next(input);
  }

  updateProfileData(input: any) {
    this.updateProfile.next(input);
  }

  getProfileData(input: any) {
    this.getProfileUpdated.next(input);
  }

  getToast(input: any) {
    this.getToastMessage.next(input);
  }
}
